module.exports = __webpack_public_path__ + "static/media/prep-layers.6c896c33.png";